export const INCOMPLETE_TASK_HELPER_TEXT = 'You can submit after attempting all tasks.'
